<template>
  <div>
    <table class="VueTables__table table is-bordered is-fullwidth is-striped">
      <thead>
      <th></th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.dispositif') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.materiel') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.face') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.format') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.adresse') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.CP') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.ville') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.reseau') }}</th>
      <th>{{ $t('addEditTourneeModele.associesFaceReseau.table.commercialisable') }}</th>
      </thead>
      <draggable v-model="tourneeModele.tourneeLignes" tag="tbody"
                 handle='.draggable-handle' @change="changeOrdre">
        <tr v-for="(tourneeLigne, index) in tourneeModele.tourneeLignes" :key="index">
          <td>
            <b-icon class="drag draggable-handle mgt-3px" icon="drag">
            </b-icon>
          </td>
          <td>{{ tourneeLigne.dispositifLibelle }}</td>
          <td>{{ tourneeLigne.materielLibelle }}</td>
          <td>{{ tourneeLigne.face }}</td>
          <td>{{ tourneeLigne.formatLibelle }}</td>
          <td>{{ tourneeLigne.adresse }}</td>
          <td>{{ tourneeLigne.cp }}</td>
          <td>{{ tourneeLigne.ville }}</td>
          <td>{{ tourneeLigne.reseau }}</td>
          <td>{{ $t(tourneeLigne.commercialisable ? 'general.oui' : 'general.non') }}</td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>

import draggable from 'vuedraggable';

export default {
  props: {
    tourneeModele: {
      type: Object,
      required: true,
    },
  },
  components: {
    draggable,
  },
  methods: {
    changeOrdre() {
      const ordres = this.tourneeModele.tourneeLignes.map(face => parseInt(face.ordre, 10));
      ordres.sort((a, b) => a - b);
      this.tourneeModele.tourneeLignes.forEach((face, index) => {
        face.ordre = (index + 1) * 10;
      });
    },
  },
};

</script>
